import { useParams, useNavigate } from "react-router-dom";
import AddVisit from "./AddVisit";
import PreviousVisitCard from "./PreviousVisitCard";
import { useEffect, useState } from "react";
import { getPreviousVisits, getVisit, getClinicVisitType } from "../../apis/visit";
import { Visit } from "../../interfaces/Visit";
import { format } from "date-fns";
import { useAppDispatch } from "../../hooks";
import { changeVisit } from "../../features/visit/visitSlice";
import { getPatient } from "../../apis/patient";
import LoaderComponent from "../../components/LoaderComponent";
import { Collapse } from "antd";

const VisitTimeline = () => {
  const [previousVisits, setPreviousVisit] = useState<Array<Visit>>([]);
  const [visit, setVisit] = useState<Visit>();
  const [patient, setPatient] = useState<any>(null);
  const [clinicVisitType, setClinicVisitType] = useState<any>(null);
  const params = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [isLoader, setLoader] = useState<boolean>(false);
  useEffect(() => {
   
    if (params.visitId) {
      fetchVisit(params.visitId);
    }
    if (params.patientId) {
      fetchPatient(params.patientId);
    }
    if (params.clinicVisitTypeId) {
      fetchClinicVisitType(params.clinicVisitTypeId);
    }
  }, []);

  // Redirect to IPD timeline if this is an inpatient visit
  useEffect(() => {
    if (clinicVisitType && clinicVisitType.visitType.type === "ipd") {
      navigate(`/ipd/visits/${params.visitId}`, { replace: true });
    }
  }, [visit, params.visitId, navigate]);

  const fetchPatient = (patientId: any) => {
    getPatient(patientId).then((res: any) => {
      setPatient(res.data.data);
    });
  };

  const fetchPreviousVisit = (id: any) => {
    getPreviousVisits(id).then((res: any) => {
      setPreviousVisit(res.data.data);
    });
  };

  const fetchVisit = async (id: any) => {
    setLoader(true);
    await getVisit(id).then(async (res: any) => {
      dispatch(changeVisit(res));
      setVisit(res);
      setLoader(false);
      setPatient(res.patient);
      if (res.parentId) {
        fetchPreviousVisit(res.parentId);
      }
    });
  };

  const fetchClinicVisitType = (id: any) => {
    getClinicVisitType(id).then((res: any) => {
      setClinicVisitType(res.data);
    });
  };

  return (
    <div className="flex flex-col flex-grow">
      <main className="flex flex-col flex-grow bg-[#ECEFFF] rounded-md">
        <div className="p-2">
          <ol className="relative border-l-2 border-primary">
            <li className="mb-4 ml-4">
              <div className="absolute w-4 h-4 border border-white rounded-full bg-primary -left-2 "></div>
              <time className="pb-2 text-sm font-normal leading-none text-active dark:text-gray-500">
                Patient Info
              </time>
              {/* <div className="grid grid-cols-3 gap-4 p-4 mb-5 bg-white rounded">
                <div className="flex w-full">
                  <span className="font-medium text-gray-900">
                    Patient Name:{" "}
                  </span>
                  <span className="ml-2 text-gray-800 capitalize">
                    {patient?.firstName} {patient?.lastName}
                  </span>
                </div>
                <div className="flex w-full">
                  <span className="font-medium text-gray-900">Reg. No.: </span>
                  <span className="ml-2 text-gray-800">
                    {patient?.registrationNumber}
                  </span>
                </div>
                <div className="flex w-full">
                  <span className="font-medium text-gray-900">Phone: </span>
                  <span className="ml-2 text-gray-800">{patient?.phone}</span>
                </div>

                <div className="flex w-full">
                  <span className="font-medium text-gray-900">Previous Surgeries: </span>
                  <span className="ml-2 text-gray-800">
                    {patient?.historyData?.previousSurgeries?.map((s: any) => s.label).join(", ") || "-"}
                  </span>
                </div>

                <div className="flex w-full">
                  <span className="font-medium text-gray-900">Allergies: </span>
                  <span className="ml-2 text-gray-800">
                    {patient?.historyData?.allergies?.map((a: any) => a.label).join(", ") || "-"}
                  </span>
                </div>

                <div className="flex w-full">
                  <span className="font-medium text-gray-900">Previous Diseases: </span>
                  <span className="ml-2 text-gray-800">
                    {patient?.historyData?.previousDiseases?.map((d: any) => d.label).join(", ") || "-"}
                  </span>
                </div>

                <div className="flex w-full">
                  <span className="font-medium text-gray-900">Ongoing Medicines: </span>
                  <span className="ml-2 text-gray-800">
                    {patient?.historyData?.ongoingmedicines?.map((d: any) => d.label).join(", ") || "-"}
                  </span>
                </div>

                <div className="flex w-full flex-col">
                  <span className="font-medium text-gray-900 mb-2">Patient Habits:</span>
                  <div className="flex flex-wrap gap-4">
                    {patient?.isAlcoholic && (
                      <span className="px-2 py-1 text-gray-800 bg-gray-100 rounded">Alcohol</span>
                    )}
                    {patient?.isSmoking && (
                      <span className="px-2 py-1 text-gray-800 bg-gray-100 rounded">Smoking</span>
                    )}
                    {patient?.isBloodDisorder && (
                      <span className="px-2 py-1 text-gray-800 bg-gray-100 rounded">Blood Disorder</span>
                    )}
                    {patient?.isBloodPressure && (
                      <span className="px-2 py-1 text-gray-800 bg-gray-100 rounded">Blood Pressure</span>
                    )}
                    {patient?.isDiabetic && (
                      <span className="px-2 py-1 text-gray-800 bg-gray-100 rounded">Diabetic</span>
                    )}
                    {!patient?.isAlcoholic &&
                      !patient?.isSmoking &&
                      !patient?.isBloodDisorder &&
                      !patient?.isBloodPressure &&
                      !patient?.isDiabetic && <span className="text-gray-500">No habits recorded</span>}
                  </div>
                </div>

                <div className="flex w-full">
                  <span className="font-medium text-gray-900">
                    Visit Type:{" "}
                  </span>
                  <span className="ml-2 text-gray-800 capitalize">
                    {clinicVisitType?.visitType?.name}
                  </span>
                </div>
              </div> */}
               <div className="mb-5 bg-white rounded">
                <Collapse
                  items={[
                    {
                      key: "1",
                      label: (
                        <span className="text-sm font-medium text-gray-900 capitalize">
                          {patient?.firstName} {patient?.lastName} - {patient?.registrationNumber}
                        </span>
                      ),
                      children: (
                        <div className="grid grid-cols-3 gap-4 p-4">
                          <div className="flex w-full">
                            <span className="font-medium text-gray-900">
                              Patient Name:{" "}
                            </span>
                            <span className="ml-2 text-gray-800 capitalize">
                              {patient?.firstName} {patient?.lastName}
                            </span>
                          </div>
                          <div className="flex w-full">
                            <span className="font-medium text-gray-900">Reg. No.: </span>
                            <span className="ml-2 text-gray-800">
                              {patient?.registrationNumber}
                            </span>
                          </div>
                          <div className="flex w-full">
                            <span className="font-medium text-gray-900">Phone: </span>
                            <span className="ml-2 text-gray-800">{patient?.phone}</span>
                          </div>

                          <div className="flex w-full">
                            <span className="font-medium text-gray-900">Previous Surgeries: </span>
                            <span className="ml-2 text-gray-800">
                              {patient?.historyData?.previousSurgeries?.map((s: any) => s.label).join(", ") || "-"}
                            </span>
                          </div>

                          <div className="flex w-full">
                            <span className="font-medium text-gray-900">Allergies: </span>
                            <span className="ml-2 text-gray-800">
                              {patient?.historyData?.allergies?.map((a: any) => a.label).join(", ") || "-"}
                            </span>
                          </div>

                          <div className="flex w-full">
                            <span className="font-medium text-gray-900">Previous Diseases: </span>
                            <span className="ml-2 text-gray-800">
                              {patient?.historyData?.previousDiseases?.map((d: any) => d.label).join(", ") || "-"}
                            </span>
                          </div>

                          <div className="flex w-full">
                            <span className="font-medium text-gray-900">Ongoing Medicines: </span>
                            <span className="ml-2 text-gray-800">
                              {patient?.historyData?.ongoingmedicines?.map((d: any) => d.label).join(", ") || "-"}
                            </span>
                          </div>
                          <div className="flex w-full">
                            <span className="font-medium text-gray-900">Patient Habits: </span>
                            <span className="ml-2 text-gray-800">
                              {(() => {
                                const habits = [];
                                if (patient?.isAlcoholic) habits.push("Alcohol");
                                if (patient?.isSmoking) habits.push("Smoking");
                                if (patient?.isBloodDisorder) habits.push("Blood Disorder");
                                if (patient?.isBloodPressure) habits.push("Blood Pressure");
                                if (patient?.isDiabetic) habits.push("Diabetic");
                                return habits.length > 0 ? habits.join(", ") : "No habits recorded";
                              })()}
                            </span>
                          </div>

                          <div className="flex w-full">
                            <span className="font-medium text-gray-900">
                              Visit Type:{" "}
                            </span>
                            <span className="ml-2 text-gray-800 capitalize">
                              {visit?.clinicVisitType?.visitType.name
                                ? visit.clinicVisitType.visitType.name
                                : clinicVisitType?.name}
                            </span>
                          </div>
                        </div>
                      ),
                    },
                  ]}
                />
              </div>
            </li>
            <li className="mb-4 ml-4">
              <div className="absolute w-4 h-4 bg-primary rounded-full mt-1.5 -left-2 border border-white "></div>
              <time className="mb-1 text-sm font-normal leading-none text-active dark:text-gray-500">
                <span>
                  {visit &&
                    visit.date &&
                    format(new Date(visit?.date), "yyyy-MM-dd")}
                </span>
              </time>
              {isLoader ? <LoaderComponent /> : <AddVisit />}
            </li>

            {previousVisits &&
              previousVisits.length > 0 &&
              previousVisits.map((i, index: number) => (
                <li className="ml-4" key={index}>
                  <PreviousVisitCard key={i.id} previousVisit={i} />
                </li>
              ))}
          </ol>
        </div>
      </main>
    </div>
  );
};

export default VisitTimeline;
